<template>
  <div class="login-enter-phone-number">
    <div class="ri-medium-bold-headline">
      היי, טוב לראות אותך
    </div>

    <div class="content">
      <div class="ri-large-body margin-top-xxs">
        האתגר קורה בווטסאפ, מיד נשלח לך קוד אימות ב-WhatsApp לאימות של מספר הטלפון שלך.
      </div>
      <text-input
        class="margin-top-l"
        :value="phoneNumber"
        :autofocus="false"
        :label-text="'טלפון נייד'"
        :on-input="setPhoneNumber"
        :error="!!errorLabel"
        :top-left-label="errorLabel"
        :input-type="'text'"
        :input-pattern="'\\d*'"
      />
    </div>
    <riseup-button
      class="hug-button"
      :title="'לקבלת קוד ב-WhatsApp'"
      :action="enterPhoneNumber"
      :disabled="loading || authLoading || !!errorLabel"
      :loading="loading || authLoading"
    />
    <div class="join ri-large-body">
      עוד לא נרשמת לשירות? <span
        class="clickable"
        @click="onSignupClick"
      >כאן נרשמים</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import RiseupButton from '@riseupil/base-ui/src/components/RiseupButton/RiseupButton.vue';
import TextInput from '@riseupil/base-ui/src/components/Inputs/TextInput.vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useLoginStore } from '../../stores/login';
import { useAuthenticationStore } from '../../stores/authentication';
import { parseAuthenticationError } from '../../utils/LoginErrorParser';
import Segment from '../../Segment';

interface Props {
  next(phoneNumber: string): void,
}
const props = defineProps<Props>();
const route = useRoute();
const router = useRouter();
const loginStore = useLoginStore();
const authenticationStore = useAuthenticationStore();
const errorLabel = ref<string>('');
const { phoneNumber, loading, normalizedPhoneNumber } = storeToRefs(loginStore);
const { loading: authLoading } = storeToRefs(authenticationStore);

loginStore.setPhoneNumber(route.query.phoneNumber as string || '');

function onSignupClick() {
  Segment.trackUserInteraction('Login_ToSignupClicked');
  router.push({ path: '/signup', query: route.query });
}
function setPhoneNumber(value: string) {
  errorLabel.value = '';
  loginStore.setPhoneNumber(value);
}
const enterPhoneNumber = async () => {
  Segment.trackUserGot('Login_EnterPhoneNumber_NextClicked', { phoneNumber: phoneNumber.value });
  try {
    await authenticationStore.generateCode(normalizedPhoneNumber.value);
    props.next(phoneNumber.value);
  } catch (e) {
    errorLabel.value = parseAuthenticationError(e);
    Segment.trackUserGot('Login_EnterPhoneNumber_ErrorGeneratingCode', { errorLabel: errorLabel.value });
  }
};
</script>

<style lang="scss" scoped>
  @import 'base-ui-vue3/src/scss/riseup-colors';

  .login-enter-phone-number {
    .title {
      padding: 18px 0px;
      font-family: SimplerProBold;
      font-size: 28px;
      line-height: 28px;
    }

    .riseup-button {
      width: 100%;
      margin: 10px 0px;
    }

    .clickable {
      color: $riseup_blue;
      font-weight: bold;
      cursor: pointer;
      text-decoration: underline;
    }

    .hug-button {
      height: 58px;
    }

    .join {
      margin: 30px 0px;
      text-align: center;
    }
  }

</style>
